window.addEventListener("DOMContentLoaded", function () {
  const isMobile = window.matchMedia("(max-width: 639px)");

  // Required inputs
  let forms = document.querySelectorAll('.gform_wrapper form');
  forms.forEach((form) => {
    form.removeAttribute('novalidate');
  });
  let formelems = document.querySelectorAll('.gfield_contains_required input, .gfield_contains_required textarea, .gfield_contains_required select');
  formelems.forEach((formelem) => {
    formelem.required = true;
  });

  // Content block image slider
  document.querySelectorAll(".image-slider").forEach((element) => {
    new Swiper(element, {
      effect: "fade",
      fadeEffect: { crossFade: true },
      speed: 1000,
      loop: true,
      grabCursor: true,
      navigation: {
        prevEl: element.querySelector(".swiper-button-prev"),
        nextEl: element.querySelector(".swiper-button-next"),
      },
    });
  });

  document.querySelectorAll(".carousel").forEach((element) => {
    const carousel = new Carousel({
      root: element,
      gap: 194,
    });
  });

  document.querySelectorAll(".small-slider").forEach((element) => {
    const carousel = new SmallCarousel({
      root: element,
    });
  });

  // Scroll Aware Navigation
  document.querySelectorAll(".scroll-aware-nav").forEach((element) => {
    const nav = new ScrollAwareNav({ element });
  });

  // Custom number inputs
  document.querySelectorAll(".number-input").forEach((element) => {
    const numberInput = new NumberInput({ element });
  });

  if (isMobile) {
    document.querySelectorAll(".grid-carousel").forEach((element) => {
      const carousel = new SmallCarousel({
        root: element,
      });
    });
  }

  // Responsive nav
  responsiveNav();

  // Header
  headerAnimation();

  // Home Images
  animateHomeImages();

  // Page scroll to content
  pageScrollToContent();

  // Burger menu
  burgerMenuSetup();

  // Booking menu
  bookingMenuSetup();

  // Overlay menu
  menuAnimation();
});

window.addEventListener("resize", function () {
  responsiveNav();
});

function archivePage(){
  const addArchiveText = document.getElementById('scroll-to-content');
  const mainCol = document.getElementById('main-col');
  addArchiveText.innerHTML += '<div class="bg-primary-default text-font-black p-4 mt-4 flex items-center gap-x-2"><img src="/wp-content/themes/bomans.se/static/images/error_offer.svg" class="w-8 lg:w-12"><div>Erbjudandet är inte aktivt för tillfället, under <a href="/kalender/" class="text-font-black underline transition-colors duration-200 hover:text-primary-hover">What\'s on</a> ser du vad som händer hos oss just nu</div></div>';
  mainCol.classList.add("archive-overflow","overflow-hidden","max-h-[100vh]","relative");
  mainCol.innerHTML += '<div class="top-[70vh] w-full h-[30vh] absolute bg-gradient-to-t from-[#2B2B2B] to-transparent"></div>';
}

let bookingMenuTween;

function openBookingMenuPanel() {
  document.body.classList.add("overflow-hidden");
  bookingMenuTween.play();
}

function triggerRestBooking() {
  const trigger_tab = document.getElementById('food-tab');
  openBookingMenuPanel();
  trigger_tab.click();
}

function triggerConfBooking() {
  const trigger_tab = document.getElementById('conf-tab');
  openBookingMenuPanel();
  trigger_tab.click();
}

function triggerHotelBooking() {
  const trigger_tab = document.getElementById('hotel-tab');
  openBookingMenuPanel();
  trigger_tab.click();
}

function responsiveNav() {
  // Header nav
  const headerNav = document.querySelector("#header-nav");
  const headerNavMenu = document.querySelector("#header-nav-menu");
  const children = headerNav.children;
  let totalWidth = 0;

  if (!headerNavMenu.classList.contains("hidden")) {
    headerNavMenu.dataset.width = headerNavMenu.offsetWidth;
  }

  for (var i = 0; i < children.length; i++) {
    if (children[i] !== headerNavMenu) {
      totalWidth += parseInt(children[i].offsetWidth, 10);
    }
  }

  totalWidth += parseInt(headerNavMenu.dataset.width, 10) || 0;

  if (totalWidth <= headerNav.offsetWidth) {
    headerNavMenu.classList.remove("hidden");
  } else {
    headerNavMenu.classList.add("hidden");
  }
}

function headerAnimation() {
  const headerTween = gsap.to(document.querySelector("#header"), {
    paddingTop: "22px",
    paddingBottom: "22px",
    backgroundColor: "#2b2b2b",
    duration: 0.5,
    ease: "linear",
    paused: true,
  });
  const burgerButtonsTween = gsap.to(document.querySelector("#burger-nav"), {
    paddingTop: "22px",
    duration: 0.5,
    ease: "linear",
    paused: true,
  });

  // Scroll To top animation
  const scrollToTopButton = document.querySelector("#scroll-to-top");
  const scrollToTopButtonTween = gsap.fromTo(
    scrollToTopButton,
    {
      scale: 0.5,
      opacity: 0,
      display: "none",
    },
    {
      scale: 1,
      opacity: 1,
      display: "block",
      duration: 0.1,
      ease: "linear",
      paused: true,
    },
    0
  );

  scrollToTopButton.addEventListener("click", function () {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  });

  window.onscroll = function (e) {
    const progress = gsap.utils.mapRange(
      0,
      152,
      0,
      1,
      gsap.utils.clamp(0, 152, window.scrollY)
    );

    burgerButtonsTween.progress(progress);
    headerTween.progress(progress);

    // Animate sroll to top button
    if (window.scrollY > 0) {
      scrollToTopButtonTween.play();
    } else {
      scrollToTopButtonTween.reverse();
    }
  };
}

function burgerMenuSetup() {
  document.querySelectorAll(".burger-menu > li").forEach((menuItem) => {
    const submenu = menuItem.querySelector(".burger-submenu");
    if (submenu) {
      const button = menuItem.querySelector(".dropdown-button");

      const submenuTimeline = gsap.timeline({
        paused: true,
      });
      submenuTimeline
        .fromTo(
          submenu,
          {
            height: 0,
          },
          {
            height: "auto",
            duration: 0.1,
            ease: "linear",
          },
          0
        )
        .fromTo(
          submenu.querySelector(".burger-submenu ul"),
          {
            y: "-100%",
          },
          {
            y: 0,
            duration: 0.1,
            ease: "linear",
          },
          0
        )
        .fromTo(
          button.querySelector(".icon-arrow-down"),
          {
            scaleY: 1,
          },
          {
            scaleY: -1,
            duration: 0.1,
            ease: "linear",
          },
          0
        );

      button.addEventListener("click", function () {
        if (submenuTimeline.progress() === 1) {
          submenuTimeline.reverse();
        } else {
          submenuTimeline.play();
        }
      });
    }
  });
}

function bookingMenuSetup() {
  const bookingMenu = document.querySelector("#booking-menu");

  bookingMenu.querySelectorAll(".tabs > button").forEach((button, index) => {
    button.addEventListener("click", function (e) {
      bookingMenu.querySelectorAll(".tabs > button").forEach((b) => {
        b.classList.remove("!border-[#BCA582]");
        b.classList.remove("opacity-100");
      });
      button.classList.add("!border-[#BCA582]");
      button.classList.add("opacity-100");
      bookingMenu
        .querySelectorAll(".tab-content")
        .forEach((tabContent, contentIndex) => {
          tabContent.classList.remove("hidden");
          if (index !== contentIndex) {
            tabContent.classList.add("hidden");
          }
        });
    });
  });
}

function menuAnimation() {
  // Burger menu animation
  const burgerNavTween = gsap.to(document.querySelector("#burger-nav"), {
    opacity: 1,
    display: "block",
    duration: 0.1,
    ease: "linear",
    paused: true,
  });

  document
    .querySelector("#burger-nav-button")
    .addEventListener("click", function () {
      document.body.classList.add("overflow-hidden");
      burgerNavTween.play();
    });
  document
    .querySelector("#burger-nav-close-button")
    .addEventListener("click", function () {
      document.body.classList.remove("overflow-hidden");
      burgerNavTween.reverse();
    });

  // Booking menu animation
  bookingMenuTween = gsap.to(document.querySelector("#booking-menu"), {
    x: "0",
    duration: 0.3,
    ease: "linear",
    paused: true,
  });

  // Open booking menu
  // Not every page renders a #booking-menu-button (it's conditional on other blocks),
  // so this listener is optional — the trigger*Booking() functions open the panel directly.
  document
    .querySelector("#booking-menu-button")
    ?.addEventListener("click", openBookingMenuPanel);

  // Close booking menu
  document
    .querySelector("#booking-menu-close-button")
    .addEventListener("click", function () {
      document.body.classList.remove("overflow-hidden");
      bookingMenuTween.reverse();
    });

  // Open booking menu and close burger menu
  document
    .querySelector("#burger-booking-menu-button")
    .addEventListener("click", function () {
      bookingMenuTween.play();
      burgerNavTween.reverse();
    });
}

function animateHomeImages() {
  const homeImagesTimeline = gsap.timeline();
  const leftImage = document.querySelector("#home-images > img:first-child");
  const middleImage = document.querySelector("#home-images > img:nth-child(2)");
  const rightImage = document.querySelector("#home-images > img:last-child");

  if (!leftImage || !middleImage || !rightImage) {
    return;
  }

  homeImagesTimeline.fromTo(
    leftImage,
    {
      x: "100%",
      opacity: 0,
    },
    {
      x: "20%",
      opacity: 1,
      duration: 0.6,
      ease: "back",
    },
    0.5
  );

  homeImagesTimeline.fromTo(
    middleImage,
    {
      y: "50%",
      opacity: 0,
    },
    {
      y: 0,
      opacity: 1,
      duration: 0.6,
      ease: "linear",
    },
    0
  );

  homeImagesTimeline.fromTo(
    rightImage,
    {
      x: "-100%",
      opacity: 0,
    },
    {
      x: "-20%",
      opacity: 1,
      duration: 0.6,
      ease: "back",
    },
    0.5
  );
}

function pageScrollToContent() {
  const scrollToButton = document.querySelector("#scroll-to-button");
  if (scrollToButton) {
    scrollToButton.addEventListener("click", function () {
      const scrollTo = document.querySelector("#scroll-to-content");
      scrollTo.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest",
      });
    });
  }
}
